<fieldset>
	<legend>{{ 'SIGALE_ANGULAR.COMPONENTS.API_DOCS.TITRE_API_DOCS' | translate }}</legend>
	<hr *ngIf="!modeApplicationCohabitation">
	<div class="swagger center mx-auto text-center">
		<button type="button" class="btn btn-link" (click)="ouvrirSwagger()">{{ 'SIGALE_ANGULAR.COMPONENTS.API_DOCS.API_DOCS_LINK' | translate }}</button>
	</div>
</fieldset>
